import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saInterCuHandinChartConfig } from '../chartConfigs';

interface InterCuHandinSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuHandinSaEcharts: React.FC<InterCuHandinSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saInterCuHandinChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default InterCuHandinSaEcharts;
